export const fileDownload = (res: BlobPart, isZip: boolean, title = 'download') => {
  const blob = new Blob([res], {type: isZip ? 'application/zip' : 'application/pdf'});
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${title}.${isZip ? 'zip' : 'pdf'}`);
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    URL.revokeObjectURL(url);
    link.remove();
  }, 100);
}